import React from "react";

import Skeleton from "@/components/shared/Skeleton";

// One axis of the permission diff — added, updated or removed. The label always
// says which axis, so `colorClass` only reinforces it.
const CountTile = ({ label, value, colorClass, loading }) => (
    <div className={`rounded-md ${colorClass} px-2 py-1 flex items-center justify-between`}>
        <span className="opacity-80">{label}</span>
        {loading ? (
            <Skeleton className="h-3 w-4" />
        ) : (
            <span className="font-mono font-semibold">{value}</span>
        )}
    </div>
);

export default CountTile;
